<template>
  <v-app id="inspire">
    <template v-if="!$route.meta.allowAnonymous">
        <v-content>
          <router-view></router-view>
        </v-content>
    </template>
    <template v-else>
      <navigation :toggle="drawer"/>
      <toolbar @toggleNavigationBar="drawer = !drawer" :name="$route.meta.name"/>
      <v-content> <!-- class="theme" -->
          <router-view />
      </v-content>
        <v-footer color="#1976D2" app >
          <span class="white--text"> {{name}} &copy; {{ year() }}</span>
          <v-spacer></v-spacer>
          <span class="white--text"> Version {{ version }}</span>

        </v-footer>
    </template>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    drawer: false,
    name: process.env.VUE_APP_COMPANY_NAME,
    version: process.env.VUE_APP_VERSION
  }),
  mounted () {

  },
  methods: {
    year () {
      const year = new Date().toISOString().substr(0, 4)
      return year
    }
  }
}
// iisexpress-proxy 3000 to 3024
</script>
<style scoped>
.theme{
  background-color: #d6d6d6;
}
</style>
